import axiosClient from "utils/api";
const URI = "/admin";

export const getDashboard = async () => {
  const URL = `${URI}/ceph/dashboard`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    console.log(response);
    return response.data;
  } catch (error) {
    console.error("Error occurred during dashboard:", error);
    throw error;
  }
};
